import {esVarNullUndef} from './validacion.js';
import {getRndInt} from './numeros.js';
import {reemplazarMultiplesSpacios} from './cadenas.js';

/**
 *Valida si es un cliente o una empresa, si es un cliente concatena sus datos, caso contrario pone la razon social
 * @param {*} Objeto con los datos del cliente
 * @param {*} Opciones para incluir el nro de codigo o el nro de Doc
 * @returns denominacion
 */
export function denominacionCliente(
   {codigo, razonSocial, apPaterno, apMaterno, nombre, nroDoc},
   {incluirCodigo, incluirNroDoc} = {incluirCodigo: true, incluirNroDoc: false}
) {
   let denominacion = '';
   if (esVarNullUndef(razonSocial) || razonSocial === '') {
      denominacion = `${nombre || ''} ${apPaterno || ''} ${apMaterno || ''}`;
   } else {
      denominacion = razonSocial;
   }

   if (incluirNroDoc) {
      denominacion = `${nroDoc} - ${denominacion}`;
   }

   if (incluirCodigo) {
      denominacion = `${codigo} - ${denominacion}`;
   }

   return reemplazarMultiplesSpacios(denominacion);
}

/**
 * Genera un identificador unico en base a los caracteres definido en la funcion
 * @param {numberq} longitud de la clave
 * @returns UUID
 */
export async function generarUuid(longitud) {
   const caracteres = 'ABSDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
   let arr = [];
   for (let index = 0; index < longitud; index++) {
      arr[index] = caracteres.charAt(getRndInt(0, 35));
   }
   return arr.join('');
}

/**
 * Genera el codigo decimal de los permisos CRUD que se desee siguiendo la siguiente regla: De izquierda a derecha, en la representacion binaria del codigo del permiso, cada digito representa un permiso de la operaciones CRUD respectivamente, 1 si se tiene el permiso y 0 caso contrario.
 *
 * @param {number} [Create=0] - Valor del permiso para crear o insertar datos. Si toma un valor mayor a 1 se le considerara como permiso otorgado.
 * @param {number} [Read=0] - Valor del permiso para leer datos. Si toma un valor mayor a 1 se le considerara como permiso otorgado.
 * @param {number} [Update=0] - Valor del permiso para actualizar datos. Si toma un valor mayor a 1 se le considerara como permiso otorgado.
 * @param {number} [Delete=0] - Valor del permiso para eliminar datos. Si toma un valor mayor a 1 se le considerara como permiso otorgado.
 * @returns {number} El valor de la convinaciones de permisos descritos.
 */
export function genPermisos(Create = 0, Read = 0, Update = 0, Delete = 0) {
   Create = Create > 1 ? 1 : Create;
   Read = Read > 1 ? 1 : Read;
   Update = Update > 1 ? 1 : Update;
   Delete = Delete > 1 ? 1 : Delete;
   let parcial = Create.toString() + Read.toString() + Update.toString() + Delete.toString();
   return parseInt(parcial, 2);
}

/**
 * Traduce un codigo de permisos a un objeto con los permisos en un formato mas facil de entender
 *
 * @param {number} codPermiso - Codigo de la combinacion de permisos, puede tomar valores de 0-15
 * @returns {permisos} Objeto con la lista de permisos: Create, Read, Update, Delete; con valores de true o false dependiendo del codigo
 */
export function getPermisos(codPermiso) {
   //Nos aseguramos que el codigo enviado es exista y sea valido
   let codigo = 0;
   if (codPermiso) {
      if (codPermiso > 15) {
         codigo = 15;
      } else if (codPermiso < 0) {
         codigo = 0;
      } else {
         codigo = codPermiso;
      }
   }
   //Convertimos el codigo a binario
   let parcial = codigo.toString(2);
   //Rellenamos con 0 a la izquierda hasta tener 4 digitos
   while (parcial.length < 4) {
      parcial = '0' + parcial;
   }
   //Rellenamos el objeto resultado de acuerdo a la siguiente regla: De izquierda a derecha,en el numero binario, cada digito representa un permiso de la operaciones CRUD, 1 si se tiene el permiso y 0 caso contrario.respectivamente.
   const permisos = {
      create: parcial[0] == 1 ? 1 : 0,
      read: parcial[1] == 1 ? 1 : 0,
      update: parcial[2] == 1 ? 1 : 0,
      delete: parcial[3] == 1 ? 1 : 0
   };
   return permisos;
}

/**
 * Traduce un codigo de permisos a un objeto con los permisos en un formato mas facil de entender
 *
 * @param {Array} arreglo - Arreglo de objetos de los cual se desea concatener una de sus propiedades.
 * @param {string} propiedad - Identificador de la propiedad de los objetos de @arreglo que se desea concatenar, si uno de los objetos no tiene definida dicha propiedad, el objeto sera ignorado
 * @param {string} enlace - Cadena usada para enlazar los valores obtenidos
 * @returns {cadena} Cadena con todos los campos @propiedad de @arreglo concatenados usando @enlace
 */
export async function concatAtributoObjetoArreglo(arreglo, propiedad, enlace = ',') {
   return await arreglo.reduce((prev, curr, index) => {
      if (curr[propiedad]) {
         if (index === 0) {
            return `${prev}${curr[propiedad]}`;
         }
         return `${prev}${enlace}${curr[propiedad]}`;
      }
      return prev;
   }, '');
}

export function arrayToTree(
   dataset,
   idName = 'id',
   idPadreName = 'idPadre',
   childrenName = 'nodes',
   getData = function (data) {
      return data;
   }
) {
   const hashTable = Object.create(null);
   dataset.forEach((aData) => (hashTable[aData[idName]] = {...getData(aData), [childrenName]: []}));
   const dataTree = [];
   dataset.forEach((aData) => {
      if (aData[idPadreName]) {
         hashTable[aData[idPadreName]][childrenName].push(hashTable[aData[idName]]);
      } else {
         dataTree.push(hashTable[aData[idName]]);
      }
   });
   return dataTree;
}

export function encodeBase(cadena) {
   return Buffer.from(cadena).toString('base64');
}

export const generateRamdonString = function (length) {
   let randomString = '';
   const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

   for (var i = 0; i < length; i++) {
      randomString += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
   }

   return randomString;
};

export function getHashQueryString(queryString) {
   const hashParams = {};
   const r = /([^&;=]+)=?([^&;]*)/g;
   const q = queryString.substring(1);

   let e;
   while ((e = r.exec(q))) {
      hashParams[e[1]] = decodeURIComponent(e[2]);
   }

   return hashParams;
}
/**
 *
 * @param {string[]} rutas Conjunto de rutas(protocolo e ip) a concatenar con los `puertos`
 * @param {string[]} puertos Conjunto de puertos a concatenar con `rutas` usando __:__
 * @returns {string[]} Arreglo con el resultado concatenar cada ruta de `rutas` con cada puerto en `puertos`
 */
export function generarIpPuerto(rutas, puertos) {
   let result = [];
   for (let ir = 0; ir < rutas.length; ir++) {
      const ruta = rutas[ir];
      for (let ip = 0; ip < puertos.length; ip++) {
         const puerto = puertos[ip];
         result.push(`${ruta}:${puerto}`);
      }
   }
   return result;
}
/*
export function generarIpPuerto(...arrCollection) {
   return arrCollection.reduce((a, b) => a.flatMap((d) => b.map((e) => [d, e].flat())));
}
*/
/**
 * Genera el periodo correspondiente a una fecha.
 * 01/04/2021 -> 2021-04
 * @param {Date} fecha Fecha de la cual se desea obtener el periodo.
 * @returns {String} Periodo correspondiente a la fecha.
 */
export function periodoFecha(fecha) {
   return `${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}`;
}
const charset =
   '!#$%&()*+,-./0123456789:<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[]^_abcdefghijklmnopqrstuvwxyz{|}~€ƒ„…†‡‰ŠŒŽ•—™šœžŸ¡¢£¤¥¦§¨©ª«¬®¯°±²³µ¶·¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬźƁƂƃƅƆƇƈƉƊƋƌƎ';
/**
 * Cifra una cadena hexadecimal usando caracteres UTF8 para reducir longitud de caracteres en la cadena al codificar con un charset de 256 caracteres.
 * @param {String} cadena Cadena que se desea cifrar.
 * @returns {String} Nueva cadena cifrada.
 */
//FUNCION ORIGINAL
export function cifrarHexToUTF8(cadena) {
   const letters = cadena.match(/.{2}/g).map((pair) => {
      return charset[parseInt(pair, 16)];
      return String.fromCharCode(parseInt(pair, 16));
   });
   return letters.join('');
}
//FUNCION REPLACE
/* 
export function cifrarHexToUTF8(cadena) {
   const bytes = (cadena.match(/.{2}/g) || []).map((pair) => {
     const intchar = parseInt(pair, 16);
     return intchar;
   });
   const buffer = Buffer.from(bytes);
   return buffer.toString('utf8');
} 
 */
/**
 * Decifra una cadena hexadecimal cifrada usando caracteres UTF8 .
 * @param {String} cadenaCifrada Cadena que se desea decifrar.
 * @returns {String} Cadena decifrada.
 */
//FUNCION ORIGINAL
export function decifrarHexToUTF8(cadenaCifrada) {
   const letters = cadenaCifrada.match(/.{1}/g).map((char) => {
      let intchar = charset.indexOf(char).toString(16);
      if (intchar.length === 1) {
         intchar = `0${intchar}`;
      }
      return intchar;
   });
   return letters.join('');
}
//FUNCION REPLACE
/* 
export function decifrarHexToUTF8(cadenaCifrada) {
  const letters = (cadenaCifrada.match(/.{2}/g) || []).map((char) => {
    const intchar = parseInt(char, 16);
    return String.fromCharCode(intchar);
  });
  return letters.join('');
} 
*/

/**
 * Separa una cadena que representa el nombre completo de una persona en sus componentes nombre1, nombre2, apellido1, apellido2
 * @param {string} nombresCompleto
 * @param {object} param1 {apellidosPrimero: boolean -> si es true quiere decir que los apellidos en `nombresCompleto` el apellido va antes de los nombres}
 * @returns
 */
export function parserNombres(nombresCompleto, {apellidosPrimero = false} = {}) {
   let inxNom1 = 0;
   let inxNom2 = 1;
   let inxAp1 = 2;
   let inxAp2 = 3;
   if (apellidosPrimero) {
      inxNom2 = 3;
      inxAp1 = 0;
      inxAp2 = 1;
   }
   const puentes = [
      'DE LA',
      'VIUDA DE',
      'VDA DE',
      'DEL',
      'LA',
      'LAS',
      'LOS',
      'MAC',
      'MC',
      'VAN',
      'VON',
      'A',
      'AS',
      'O',
      'OS',
      'Y',
      'I',
      'DO',
      'DOS',
      'DEN',
      'SAN',
      'DE'
   ];
   let nombresPreProcesado = nombresCompleto.trim();
   for (const puente of puentes) {
      const puenteDash = puente.split(' ').join('_');
      nombresPreProcesado = nombresPreProcesado.replace(` ${puente} `, `_${puenteDash}_`);
   }
   const nombresSplit = nombresPreProcesado.split(' ');
   let nombresObjeto = {
      nombre1: '',
      nombre2: '',
      apellido1: '',
      apellido2: ''
   };
   if (nombresSplit.length === 0) {
      return nombresObjeto;
   }
   if (nombresSplit.length === 1) {
      nombresObjeto.nombre1 = nombresSplit[inxNom1].replace(/_/g, ' ');
      return nombresObjeto;
   }
   if (nombresSplit.length === 2) {
      if (apellidosPrimero) {
         inxNom1 = 1;
         inxAp1 = 0;
      } else {
         inxNom1 = 0;
         inxAp1 = 1;
      }
      nombresObjeto.nombre1 = nombresSplit[inxNom1].replace(/_/g, ' ');
      nombresObjeto.apellido1 = nombresSplit[inxAp1].replace(/_/g, ' ');
      return nombresObjeto;
   }
   if (nombresSplit.length === 3) {
      if (apellidosPrimero) {
         inxNom1 = 2;
         inxAp1 = 0;
         inxAp2 = 1;
      } else {
         inxAp1 = 1;
         inxAp2 = 2;
      }
      nombresObjeto.nombre1 = nombresSplit[inxNom1].replace(/_/g, ' ');
      nombresObjeto.apellido1 = nombresSplit[inxAp1].replace(/_/g, ' ');
      nombresObjeto.apellido2 = nombresSplit[inxAp2].replace(/_/g, ' ');
      return nombresObjeto;
   }
   if (nombresSplit.length === 4) {
      if (apellidosPrimero) {
         inxNom1 = 2;
      }
      nombresObjeto = {
         nombre1: nombresSplit[inxNom1].replace(/_/g, ' '),
         nombre2: nombresSplit[inxNom2].replace(/_/g, ' '),
         apellido1: nombresSplit[inxAp1].replace(/_/g, ' '),
         apellido2: nombresSplit[inxAp2].replace(/_/g, ' ')
      };
      return nombresObjeto;
   }

   let vnom = '';
   for (let inx = 0; inx <= nombresSplit.length - 4; inx++) {
      vnom = vnom + ' ' + nombresSplit[inx];
   }
   nombresObjeto = {
      nombre1: vnom.trim().replace(/_/g, ' '),
      nombre2: nombresSplit[nombresSplit.length - 3].replace(/_/g, ' '),
      apellido1: nombresSplit[nombresSplit.length - 2].replace(/_/g, ' '),
      apellido2: nombresSplit[nombresSplit.length - 1].replace(/_/g, ' ')
   };
   return nombresObjeto;
}
/**
 *
 * @param {string|URL} base URL base a la cual se le desea agregar un recurso al final
 * @param {string} resource
 * @returns {URL} Nueva instancia URL con __resource__ agregado
 */
export function appendUrl(base, resource) {
   const newURL = new URL(base);
   if (!resource) {
      return newURL;
   }
   let newPathname = `${newURL.pathname}/${resource}`;
   newURL.pathname = newPathname.replace(/(\/)\1+/g, '$1');
   return newURL;
}
